// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules_temp/buddy/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules_temp/buddy/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#FtCO9heDj5y19Zksdeuw {\n    padding-left: 0.5em;\n}\n", "",{"version":3,"sources":["webpack://./src/fe/index/order-editor/body.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB","sourcesContent":["#body {\n    padding-left: 0.5em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": "FtCO9heDj5y19Zksdeuw"
};
export default ___CSS_LOADER_EXPORT___;
